import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import { Button } from '@helpcenter/analytics-components/src/button';
import { layer } from '@helpcenter/styles/src/z-index';
import type { GlyphProps } from '@atlaskit/icon/types';
import Tooltip from '@atlaskit/tooltip/Tooltip';

export interface HighlighterProps {
	isHighlighted?: boolean;
	highlightHandler: () => void;
	actionSubjectId: string;
	toolTip: {
		highlightedMessage: string;
		unHighlightedMessage: string;
	};
	ariaLabel: {
		highlightedLabel: string;
		unHighlightedLabel: string;
	};
	icon: {
		HighlightedIcon: React.ComponentClass<GlyphProps & { color?: string }>;
		UnHighlightedIcon: React.ComponentClass<GlyphProps & { color?: string }>;
	};
	color?: {
		highlightedColor?: string;
		unHighlightedColor?: string;
	};
}

export const Highlighter: React.FC<HighlighterProps> = ({
	isHighlighted,
	highlightHandler,
	toolTip,
	ariaLabel,
	actionSubjectId,
	icon,
	color,
}) => {
	const toolTipMessage = isHighlighted ? toolTip.highlightedMessage : toolTip.unHighlightedMessage;
	const ariaLabelContent = isHighlighted
		? ariaLabel.highlightedLabel
		: ariaLabel.unHighlightedLabel;
	const { HighlightedIcon, UnHighlightedIcon } = icon;

	return (
		<HighlighterButtonContainer>
			<Tooltip
				content={toolTipMessage}
				position="top"
				aria-hidden="true"
				hasNewContentOnTriggerClick
			>
				<Button
					type="button"
					appearance="subtle"
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
					className="project-card-action-button"
					onClick={highlightHandler}
					actionSubjectId={actionSubjectId}
					iconBefore={
						isHighlighted ? (
							<HighlightedIcon
								label={ariaLabelContent}
								color={color?.highlightedColor}
								size="medium"
							/>
						) : (
							<UnHighlightedIcon
								label={ariaLabelContent}
								color={color?.unHighlightedColor}
								size="medium"
							/>
						)
					}
				></Button>
			</Tooltip>
		</HighlighterButtonContainer>
	);
};

export default React.memo(Highlighter);

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const HighlighterButtonContainer = styled.div`
	background: transparent;
	border: 0;
	cursor: pointer;
	z-index: ${layer};
`;
